import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface EquityRommsProps {
  onBack: () => void;
}

export default function EquityRomms({ onBack }: EquityRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Equity & Reserves" />;
}
